import * as React from 'react';
import { getBidTotal } from '../pages/Enquiry/InquiryUtils';

const FrieghtPerUnit = (props) => {
  const { amount, currency, perLabel, fontColor, label } = props;
  const amountTotal = getBidTotal(amount);
  return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={ { marginRight: 10, color: fontColor || '#333', fontSize: 10 }}>
              {label || 'Freight'}</span>
            <div style={{
              fontSize: 12,
              fontWeight: 600,
              color: fontColor || '#111',
              lineHeight: '75%',
            }}>
            <span style={{ fontSize: fontColor ? 10 : 14 }}>{amountTotal}</span>
            <span style={{
              // fontSize: 10,
              // verticalAlign: 'top',
              // lineHeight: '6px',
            }}>&nbsp;{currency}</span>
            <span style={{ fontSize: 8, fontWeight: 'normal',
              color: fontColor || '#262626' }}>/ {perLabel}</span>
            </div>
        </div>
  );
};

export default FrieghtPerUnit;
